import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Getbasketorderlist,
  BrokerBasketOrderlistByClient,
} from "../../../Services/UserService/User";

import Content from "../../../components/Contents/Content";
import { fDateTimeH } from "../../../../Utils/Date_formate";
import Loader from "../../../../Utils/Loader";
import { brokerFieldMap } from "../../../../Utils/BrokerResponseArray";

const BasketResponse = () => {

  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("id");
  const location = useLocation();

  const [responsedata, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [brokerDetailsMap, setBrokerDetailsMap] = useState({});

  const getBrokerHistory = async () => {
    try {
      const data = { clientid: userid };
      const response = await Getbasketorderlist(data, token);

      if (response.status) {
        setResponseData(response?.data);
      }
    } catch (error) {
      console.log("Error fetching broker history:", error);
    }
    setIsLoading(false);
  };



  const getBrokerdata = async (orderid, index, brokerid) => {
    try {
      const data = { clientid: userid, orderid, brokerid };
      const response = await BrokerBasketOrderlistByClient(data, token);

      if (response.status) {
        let mainResponse;
        if (brokerid == 6) {
          mainResponse = response?.response?.data;
        } else if (brokerid == 7) {
          mainResponse = Array.isArray(response?.response) ? response?.response[0] : response?.response;
        } else if (brokerid == 2) {
          mainResponse = response?.response[0];
        } else if (brokerid == 5) {
          mainResponse = response?.response?.data?.slice(-1)[0];;
        } else {
          mainResponse = response?.response;
        }

        setBrokerDetailsMap((prev) => ({
          ...prev,
          [index]: mainResponse,
        }));
      }
    } catch (error) {
      console.log("Error fetching broker order data:", error);
    }
  };


  useEffect(() => {
    getBrokerHistory();
  }, []);

  const BrokerDAta = ["", "Angel", "Alice Blue", "Kotak Neo", "Market Hub", "Zerodha", "Upstox", "Dhan"];




  const getValueByPath = (obj, path) => {
    return path.split('.').reduce((acc, key) => acc?.[key], obj) || "N/A";
  };

  return (
    <Content Page_title="Broker Response" button_status={false} backForword={true}>
      <div className="accordion accordion-flush" id="accordionFlushExample">
        {isLoading ? (
          <div className="text-center my-5">
            <Loader />
          </div>
        ) : responsedata.length > 0 ? (
          responsedata.map((data, index) => (
            <div className="accordion-item rounded-3 border-0 shadow mb-2" key={data._id || index}>
              <h2 className="accordion-header">
                <button
                  className="accordion-button border-bottom collapsed fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#flush-collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`flush-collapse${index}`}
                  onClick={() => {
                    if (!brokerDetailsMap[index]) {
                      getBrokerdata(data?.orderid, index, data.borkerid);
                    }
                  }}
                >
                  <div className="d-md-flex justify-content-between align-items-center w-100">
                    <div>
                      <h5 className="me-3">Trade Symbol: {data?.tradesymbol || "N/A"}</h5>
                      <h6 className="me-3">Price: {data?.price || "N/A"}</h6>
                      <small className="me-3">Broker: {BrokerDAta[Number(data?.borkerid)] || "N/A"}</small>
                    </div>
                    <div className="d-flex flex-column">
                      <span
                        className={`badge ${data.ordertype === "BUY" ? "bg-success" : "bg-danger"} badgespan mb-2 align-self-start`}
                      >
                        {data.ordertype || "N/A"}
                      </span>
                      <h6 className="me-3">
                        {data?.createdAt ? fDateTimeH(data?.createdAt) : "N/A"}
                      </h6>
                    </div>
                  </div>
                </button>
              </h2>
              <div
                id={`flush-collapse${index}`}
                className="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  {brokerDetailsMap[index] ? (
                    <table className="table table-bordered signalstrategy-tablen">
                      <tbody>

                        {Object.entries(brokerFieldMap[data.borkerid] || {}).map(([label, path]) => {
                          const value = getValueByPath(brokerDetailsMap[index], path);
                          const displayValue = value !== undefined && value !== null && value !== '' ? value : "N/A";
                          const statusValue = String(value).toLowerCase();

                          if (label === "Status") {
                            let statusText = displayValue;
                            let statusColor = "black";

                            if (statusValue === "traded") {
                              statusText = "Completed";
                              statusColor = "green";
                            } else if (statusValue === "rejected") {
                              statusText = "Rejected";
                              statusColor = "red";
                            } else if (statusValue === "Pending") {
                              statusText = "Pending";
                              statusColor = "red";
                            } else if (statusValue === "complete") {
                              statusText = "Completed";
                              statusColor = "green";
                            } else if (statusValue === "PUT ORDER REQ RECEIVED") {
                              statusText = "Completed";
                              statusColor = "green";
                            }

                            return (
                              <tr key={label}>
                                <td>{label}</td>
                                <td style={{ color: statusColor }}>
                                  {statusText}
                                </td>
                              </tr>
                            );
                          }

                          return (
                            <tr key={label}>
                              <td className="text-white">{label}</td>
                              <td  className="text-white" style={{ wordBreak: "break-word", whiteSpace: "normal", maxWidth: "300px" }}>
                                {displayValue}
                              </td>
                            </tr>
                          );
                        })}


                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center mt-5">
                      <img
                        src="/assets/images/nodata.png"
                        alt="No Records Found"
                        style={{ maxWidth: "300px" }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center mt-5">
            <img
              src="/assets/images/nodata.png"
              alt="No Records Found"
              style={{ maxWidth: "300px" }}
            />
          </div>
        )}
      </div>
    </Content>
  );
};

export default BasketResponse;
